import { Marker, Popup } from 'react-leaflet';
import { createLeafletIconFromImage } from '../../utils/mapIcons';

import iconMap from '../../utils/mapIcons'; // Adjust the path as necessary
import { subLineMap } from '../../enum/serviceType';
import StopPopup from '../stop/StopPopup';
import { getRouteIds } from '../../utils/stopUtil';

function MRTStopMarkers({ stops, userLocation, overlappingStops }) {

    const getServiceIcon = (stop_id) => {
        // Extract the first two letters from stop_id
        const prefix = stop_id.slice(0, 2); // or use regex if needed

        // Find the matching service
        // Flatten subLineMap to a list of all lines with their category
        const allLines = Object.entries(subLineMap).flatMap(([category, lines]) =>
            lines.map(line => ({ ...line, category }))
        );
        // Find the matching line by code
        const line = allLines.find(line => line.code === prefix);
 
        const icon = createLeafletIconFromImage(iconMap[line.line], line.color); // or use "BRT" or any other symbol
        return icon
    };

    function fetchUniqueRouteIds(overlappingStops, stops, stop_lat, stop_lon) {
        const uniqueRouteIds = getRouteIds(overlappingStops, stops, stop_lat, stop_lon);
        console.log("uniqueRouteIds", uniqueRouteIds)
        return uniqueRouteIds;
    }

    return (
        <>
            {stops.map((stop) => (

                <Marker
                    key={stop.stop_id}
                    position={[parseFloat(stop.stop_lat), parseFloat(stop.stop_lon)]}
                    icon={getServiceIcon(stop.stop_id)}
                >
                    <Popup>
                        <StopPopup stop={stop} userLocation={userLocation} routeIds={fetchUniqueRouteIds(overlappingStops, stops, stop.stop_lat, stop.stop_lon)} />
                    </Popup>
                </Marker>
            ))}
        </>
    );
}

export default MRTStopMarkers;
